<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="text-center fw-bold w-100">{{ title() | translate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        @if (showMessage()) {
            <h5 class="text-center fw-bolder mb-2">{{ "metrics.metrics_delete_modal" | translate }}</h5>
        }

        <adaa-data-table
            [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.KPIS_LINKED_TO_METRIC_CONF_LIST"
            [isLocalData]="true"
            [enableAdd]="false"
            [enableEditAction]="false"
            [enableDeleteAction]="false"
            [enableFilter]="false"
            [enableSettings]="false"
            [enableExport]="false"
            [localData]="data()"
            (actionClicked)="actionClicked($event)"
        />
    </div>
    <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-primary" (click)="modal.close()">{{ "common.form.button.close" | translate }}</button>
    </div>
</ng-template>
